var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHiloDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.19643 6L3.19643 6L3.19643 0H7.19643L7.19643 6Z",
    fill: "#FFCD4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.19643 12L0.000274658 6L10.3926 6L5.19643 12Z",
    fill: "#FFCD4C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiloDown);
export default __webpack_public_path__ + "static/media/hilo-down.c09277862673fac7de4845114170dc76.svg";
export { ForwardRef as ReactComponent };